import React, { FC } from 'react';
import { PaymentOption } from '../../../../models/form/paymentOption';
import OptionList from '../optionlist/OptionList';
import { getText } from '../../../../utilities/CultureUtilities';

export interface Props {
  value: Array<string>;
  options: PaymentOption[];
  onChange: (value: string[]) => void;
  multiSelection: boolean | undefined;
  readOnlyMode?: boolean;
  culture?: string;
}

const PaymentOptionList: FC<Props> = ({ value, options, onChange, multiSelection, readOnlyMode, culture }: Props) => {
  return (
    <div className="payment-option-list">
      <OptionList
        value={value || []}
        options={options.map((option) => {
          return {
            text: (
              <div className={'d-flex option-container'}>
                <div className="option-name">{getText(option.text, culture)}</div>
                <div className="option-price">{(Number(option.price) / 100).toFixed(2) || '0.00'} $</div>
              </div>
            ),
            value: option.value,
          };
        })}
        multiSelection={multiSelection}
        onChange={onChange}
        readOnlyMode={readOnlyMode}
      ></OptionList>
    </div>
  );
};

export default PaymentOptionList;
